export const FILE_TYPES_ACCEPTED = 'image/png, image/jpg, image/jpeg';
